import styled from 'styled-components';

export const H3 = styled.h3<{ secondary?: boolean }>`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 24px;
  line-height: 36px;
  color: ${(props) => (props.secondary ? props.theme.bluePeps : props.theme.algoanBlue)};
  margin: 0;
`;
